export const fontFamily = 'Open Sans'
